import { TextField, TextFieldProps } from '@mui/material'

import { ToggleGroup, ToggleGroupProps } from '@/components/toggle-group.tsx'
import { RadioGroup, RadioGroupProps } from '@/components/radio-group.tsx'
import { Checkbox, CheckboxProps } from '@/components/checkbox.tsx'
import { FileField, FileInputProps } from '@/components/file-field.tsx'

import { createFormControl } from './form-control.tsx'
export * from './select-field-control.tsx'
export * from './submit-button.tsx'
export * from './submit-error-message.tsx'

// todo: remove autofill yellow BG
export const TextFieldControl = createFormControl<TextFieldProps>(TextField)
export const ToggleGroupControl = createFormControl<ToggleGroupProps<any>>(ToggleGroup)
export const RadioGroupControl = createFormControl<RadioGroupProps>(RadioGroup)
export const CheckboxControl = createFormControl<CheckboxProps>(Checkbox)
export const FileControl = createFormControl<FileInputProps>(FileField)
